import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Approach from "./sections/Approach";
import Credentials from "./sections/Credentials";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Story />
      <Approach />
      <Credentials />
      <Footer />
    </div>;
}